/* =========================================================
   Que el traductor del navegador no tumbe la pantalla.

   La incidencia (octubre de 2026): socios que trabajan en inglés pulsaban
   «Edit» en su organización o en un site y la página se quedaba en blanco.
   Chrome les traducía el portal —la pantalla de entrada sale en español— y
   el traductor cambia cada texto por uno suyo, envuelto en <font>. React no
   se entera: al pasar de la ficha a los campos editables va a quitar un
   texto que ya no está donde lo dejó, el navegador lanza «Failed to execute
   'removeChild' on 'Node'» y la aplicación entera se desmonta.

   La primera defensa está en index.html (translate="no"): el portal ya
   trae su español y su inglés, y la traducción del navegador sobra. Esta es
   la segunda, para el navegador que no haga caso: si React pide quitar o
   insertar junto a un nodo que el traductor ya movió, se ignora en vez de
   romper. Lo peor que pasa es que un texto traducido se quede sin
   actualizar; la pantalla sigue viva y se puede guardar.

   Solo cambia el comportamiento en el caso que antes lanzaba un error.
   ========================================================= */

let instalado = false;

export function protegerDelTraductor() {
  if (instalado || typeof Node !== 'function' || !Node.prototype) return;
  instalado = true;

  const quitar = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, hijo: T): T {
    if (hijo.parentNode !== this) {
      console.warn('ETC Connect: un nodo ya no estaba donde React lo dejó (¿traductor del navegador?)', hijo);
      return hijo;
    }
    return quitar.call(this, hijo) as T;
  };

  const insertar = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, nuevo: T, referencia: Node | null): T {
    if (referencia && referencia.parentNode !== this) {
      console.warn('ETC Connect: la referencia para insertar ya no estaba en su sitio (¿traductor del navegador?)', referencia);
      return insertar.call(this, nuevo, null) as T;
    }
    return insertar.call(this, nuevo, referencia) as T;
  };
}
